/**
 * Shortcuts are written against `Mod`, which is Cmd on Apple hardware and Ctrl everywhere else.
 * Tooltips have to say the same thing, so they are rendered from the binding rather than hardcoded.
 */
export function isApplePlatform(): boolean {
	return typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent)
}

export const isApple = isApplePlatform()

const TOKENS: Record<string, string> = isApple
	? { mod: '⌘', shift: '⇧', alt: '⌥', ctrl: '⌃' }
	: { mod: 'Ctrl', shift: 'Shift', alt: 'Alt', ctrl: 'Ctrl' }

const JOINER = isApple ? '' : '+'

/** Takes a binding such as `Mod-Shift-S` and returns what this platform calls it. */
export function shortcut(binding: string): string {
	return binding
		.split('-')
		.map(part => TOKENS[part.toLowerCase()] ?? (part.length === 1 ? part.toUpperCase() : part))
		.join(JOINER)
}
